import dynamic from "next/dynamic";

const ModalRiskReminder = dynamic(() => import("./ModalRiskReminder"), {
  ssr: false
});
export default ModalRiskReminder;
